// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jk-1";
export var messageSideRight = "_jk-2";
export var orderLookupBubbleContainer = "_jk-0";
export var submitButton = "_jk-3";